import axios from '~/utils/axios';

export const getApplications = (params: any) => {
  const { resourceId, target, ...rest } = params;
  return axios.get(`${target}/${resourceId}/applications`, { ...rest }).then((res) => res.data);
};

export const terminateApplication = (id: string | number, body?: { reason?: string }) => {
  return axios.post(`/applications/${id}/terminate`, body).then((res) => res.data);
};
